<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import { onMount } from "svelte";
	import type { HTMLDialogAttributes } from "svelte/elements";
	import cross from "@core/assets/icons/cross.svg?raw";
	import { lockScroll } from "../../state/lockScroll.svelte.js";

	let {
		show = $bindable(false),
		/* eslint-disable prefer-const */
		...rest
		/* eslint-enable prefer-const */
	}: HTMLDialogAttributes & { show: boolean } = $props();

	let dialog = $state<HTMLDialogElement | null>(null);

	$effect(() => {
		if (!dialog) {
			return;
		}

		if (show && !dialog.open) {
			dialog.showModal();
		}
		if (!show && dialog.open) {
			dialog.close();
		}
	});

	$effect(() => {
		if (show && !lockScroll.lock) {
			lockScroll.lock = true;
		}
	});
	$effect(() => {
		if (!show) {
			lockScroll.lock = false;
		}
	});

	function closeOnBackdrop(event: MouseEvent): void {
		if (!event.target) {
			return;
		}

		if (!(event.target instanceof Node)) {
			return;
		}

		if (event.target.nodeName === "DIALOG") {
			show = false;
		}
	}

	// Not using on:click because svelte complains about accessibility (non-interactable elements with a mouse/keyboard event listener).
	onMount(() => {
		dialog?.addEventListener("click", closeOnBackdrop);
		return (): void => {
			dialog?.removeEventListener("click", closeOnBackdrop);
		};
	});
</script>

<dialog
	bind:this={dialog}
	{...rest}
	class={["bg-transparent p-4 lg:min-w-96 max-w-full mx-auto", rest.class]}
	onclose={(event: Event & { currentTarget: EventTarget & HTMLDialogElement }): void => {
		show = false;
		rest.onclose?.(event);
	}}
>
	<!-- This div element makes closing on backdrop work correctly -->
	<div class="bg-white relative p-8 pt-12 rounded-3xl">
		{@render rest.children?.()}

		<button
			class="text-grey-200 hover:text-black transition-colors duration-300 absolute top-4 right-4"
			onclick={(): void => {
				show = false;
			}}
		>
			<Icon icon={cross} class="w-4" square />
		</button>
	</div>
</dialog>
